import React from 'react';
import { Shield, FileWarning, Flame, Stethoscope, AlertTriangle, ExternalLink } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Progress } from '../components/ui/progress';

const RegulatoryModulesPage = () => {
  const regulations = [
    {
      id: 1,
      title: 'COSHH Register',
      description: 'Control of Substances Hazardous to Health',
      icon: FileWarning,
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/20',
      progress: 100,
      status: 'Compliant'
    },
    {
      id: 2,
      title: 'Fire Safety Log',
      description: 'Weekly alarm tests and evacuation drills',
      icon: Flame,
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/20',
      progress: 85,
      status: 'Review Needed'
    },
    {
      id: 3,
      title: 'Allergen Matrix',
      description: 'FSA compliant menu ingredient breakdown',
      icon: AlertTriangle,
      color: 'text-red-500',
      bgColor: 'bg-red-500/20',
      progress: 60,
      status: 'Action Required'
    },
    {
      id: 4,
      title: 'First Aid Logging',
      description: 'RIDDOR reporting and first aid kit checks',
      icon: Stethoscope,
      color: 'text-green-500',
      bgColor: 'bg-green-500/20',
      progress: 100,
      status: 'Compliant'
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold font-heading text-[#FF6600] uppercase tracking-tight">
          Regulatory Modules
        </h1>
        <p className="text-[#A1A1AA] mt-1">
          Statutory compliance tracking and legal requirement registers.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {regulations.map((reg) => {
          const Icon = reg.icon;
          return (
            <Card key={reg.id} className="bg-[#1E1E1E] border-[#3F3F46] flex flex-col">
              <CardHeader className="flex flex-row items-start justify-between pb-2">
                <div className="flex gap-3">
                  <div className={`p-3 rounded-lg ${reg.bgColor}`}>
                    <Icon className={`w-6 h-6 ${reg.color}`} />
                  </div>
                  <div>
                    <CardTitle className="text-white text-lg">{reg.title}</CardTitle>
                    <CardDescription className="text-[#A1A1AA]">{reg.description}</CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="mt-auto pt-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-white">{reg.status}</span>
                  <span className="text-sm text-[#A1A1AA]">{reg.progress}%</span>
                </div>
                <Progress 
                  value={reg.progress} 
                  className="h-2 bg-[#27272A]"
                  indicatorClassName={
                    reg.progress === 100 ? 'bg-[#00E676]' : 
                    reg.progress > 70 ? 'bg-[#FFB300]' : 'bg-[#FF3B30]'
                  } 
                />
                <Button variant="ghost" className="w-full mt-4 text-[#A1A1AA] hover:text-white hover:bg-[#27272A]">
                  Open Register <ExternalLink className="w-4 h-4 ml-2" />
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default RegulatoryModulesPage;